<template>
    <div class="give-wrap">
        <!--  门店票列表选择弹框 -->
        <a-modal
            title='票券选择'
            :width="880"
            :visible="visible"
            @cancel="closeModal"
            @ok="handleCreate"
            >
            <div>
                <a-form :form="form" layout="inline">
                    <a-form-item label="票券内部标识">
                        <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                    </a-form-item>
                    <a-form-item label="票券类型">
                        <a-select style="width: 106px" allowClear placeholder="请选择" v-decorator="['type']">
                            <a-select-option value="1">期限卡</a-select-option>
                            <a-select-option value="2">次卡</a-select-option>
                            <a-select-option value="3">套餐票</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="票券状态">
                        <a-select style="width: 106px" allowClear placeholder="请选择" v-decorator="['isOnShelves']">
                            <a-select-option value="1">上架中</a-select-option>
                            <a-select-option value="0">已下架</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-button @click="search" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form>
                <a-table style="word-break:break-all;" class="mt16" :scroll="{ y: 360 }" bordered :columns="columns" :dataSource="dataSource" :pagination="false" :rowSelection="{onChange: onSelectChange, selectedRowKeys: tableSelectedRowKeys}" :rowKey="record => record.ticketTemplateId" >
                    <span slot="index" slot-scope="a,b,index">{{index+1}}</span>
                    <span slot="type" slot-scope="a">{{['', '期限卡', '次卡', '套餐票'][a]}}</span>
                    <span slot="isOnShelves" slot-scope="a">{{['已下架', '上架中'][Number(a)]}}</span>
                </a-table>
                <div class="mt16 text-fail">您共选择了： {{tableSelectedRowKeys.length}} 个票券</div>
            </div>
        </a-modal>
    </div>
</template>

<script>

    /**
     * 门店票列表选择弹框组件
     * 
     * @prop {Boolean} visible 控制弹窗是否显示
     *
     * @func closeModal 通知父组件关闭弹窗
     *
     */
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            width: 80,
            scopedSlots: { customRender: "index" }
        },
        {
            title: "票券内部标识",
            dataIndex: "name",
        },
        {
            title: "类型",
            dataIndex: "type",
            scopedSlots: { customRender: "type" },
            width: 150,
        },
        {
            title: "票券状态",
            dataIndex: "isOnShelves",
            scopedSlots: { customRender: "isOnShelves" },
            width: 150,
        },
        {
            title: "售卖价/元",
            dataIndex: "sellShowPrice",
            width: 150,
        }
    ];
    export default {
        name: "ticket-list",
        zh: "门店票列表选择弹框组件",
        data() {
            return {
                form: this.$form.createForm(this),
                columns,
                dataSource: [],
                tableSelectedRowKeys: [],
            };
        },
        props: {
            visible: {type: Boolean},
            list: {type: Array},
            selectedRowKeys: {type: Array},
        },
        watch: {
            visible(val) {
                if(val) {
                    this.dataSource = this.$utils.deepClone(this.list);
                    this.tableSelectedRowKeys = this.$utils.deepClone(this.selectedRowKeys);
                    this.tableSelectedRowKeys = this.tableSelectedRowKeys.map(item => item = item);
                    this.search()
                } else {
                    this.handleReset();
                }
            }
        },
        methods: {
            handleReset () {
                this.form.resetFields();
            },
            handleCreate() {
                this.$emit('discountTargetIds', this.tableSelectedRowKeys);
                this.$emit('changeVisible', false);
            },
            onSelectChange(selectedRowKeys, dateString) {
                this.tableSelectedRowKeys = selectedRowKeys;
            }, 
            closeModal() {
                this.$emit('changeVisible', false)
            },
            search() {
                let { name, type, isOnShelves } = this.form.getFieldsValue();
                this.dataSource = this.list.filter(item => {
                    let ticketNameCode = Boolean(name) ? new RegExp(name).test(String(item.name)) : true;
                    let ticketTypeCode = type ? item.type == type : true;
                    let stateCode = isOnShelves ? item.isOnShelves == isOnShelves : true;
                    return (ticketNameCode && ticketTypeCode && stateCode);
                });
            }
        }
    };
</script>

<style lang="scss">

</style>